import type { CourseTreeNode } from "@/types/generated";
import { useNavigate, useLocation } from "react-router-dom";
import { useCourseBasePath } from "@/hooks/useCourseBasePath";
import { stripCourseNavQueryString } from "@/lib/chapterNavigation";
import { treeTitleClass } from "@/components/course/tree/treeStyles";
import { cn } from "@/lib/utils";

interface TrainerChapterNodeProps {
  chapter: CourseTreeNode;
}

const TrainerChapterNode = ({ chapter }: TrainerChapterNodeProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const basePath = useCourseBasePath();

  return (
    <div id={`node-${chapter.id}`}>
      <button
        onClick={() =>
          navigate(
            `${basePath}/${chapter.id}${stripCourseNavQueryString(location.search)}`
          )
        }
        className="w-full flex items-center gap-2.5 pl-9 pr-5 py-2 text-left cursor-pointer hover:bg-gray-50 transition-colors"
        title={chapter.title}
      >
        <div className="flex-1 min-w-0">
          <span
            className={cn(
              "text-[16px] font-semibold block wrap-break-word leading-snug",
              treeTitleClass(false)
            )}
          >
            {chapter.title}
          </span>
        </div>
      </button>
    </div>
  );
};

export default TrainerChapterNode;
